module.exports = __webpack_public_path__ + "static/media/logo-sm.a7db612c.svg";